<template>
  <div :key="file.id">
    <v-dialog
      @keydown.esc="isOpen=false"
      persistent
      v-model="isOpen"
      fullscreen
      hide-overlay>
      <v-card>
        <v-toolbar class="noto bold" width="100%">
          <v-toolbar-title class="primary--text">Nota de Crédito</v-toolbar-title>
          <v-spacer />
          <v-btn
            fab
            depressed
            small
            color="primary"
            @click="closeDialog">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col>
              <v-row>
                <v-col class="pt-0">
                  <v-card height="100%">
                    <div class="pa-2">
                      <div class="title">
                        Factura relacionada
                      </div>
                      <v-divider />
                      <v-row>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            Folio fiscal:
                          </div>
                        </v-col>
                        <v-col class="py-1">
                          <div>
                            {{ relatedInvoice.UUID }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            Tipo de relación:
                          </div>
                        </v-col>
                        <v-col class="py-1">
                          <div>
                            {{ typesRelations(type) }}
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <v-card height="100%">
                    <div class="pa-2">
                      <div class="title">
                        Emisor
                      </div>
                      <v-divider />
                      <v-row>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            Nombre:
                          </div>
                        </v-col>
                        <v-col class="py-1">
                          <div>
                            {{ emiter.Nombre }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            RFC:
                          </div>
                        </v-col>
                        <v-col class="py-1">
                          <div>
                            {{ emiter.Rfc }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-if="emiter.RegimenFiscal">
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            Regimen Fiscal:
                          </div>
                        </v-col>
                        <v-col class="py-1" md="3">
                          <div>
                            {{ emiter.RegimenFiscal }}
                          </div>
                        </v-col>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            Método de pago:
                          </div>
                        </v-col>
                        <v-col class="py-1" md="3">
                          <div>
                            {{ payMethod }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            Forma de pago:
                          </div>
                        </v-col>
                        <v-col class="py-1">
                          <div>
                            {{ payForm }}
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-card height="100%">
                    <div class="pa-2">
                      <div class="title">
                        Receptor
                      </div>
                      <v-divider />
                      <v-row>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            Nombre:
                          </div>
                        </v-col>
                        <v-col class="py-1">
                          <div>
                            {{ receiver.Nombre }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            RFC:
                          </div>
                        </v-col>
                        <v-col class="py-1">
                          <div>
                            {{ receiver.Rfc }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1" md="3">
                          <div class="grey--text">
                            Uso de CFDI:
                          </div>
                        </v-col>
                        <v-col class="py-1">
                          <div>
                            {{ receiver.UsoCFDI }}
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-card height="100%" class="pa-2">
                <div class="d-flex justify-space-between pb-2">
                  <div class="mr-1 grey--text">
                    Folio:
                  </div>
                  <div>
                    {{ folio }}
                  </div>
                </div>
                <div class="d-flex justify-space-between pb-2">
                  <div class="mr-1 grey--text">
                    Fecha:
                  </div>
                  <div>
                    {{ date }}
                  </div>
                </div>
                <v-divider class="my-3" />
                <div class="d-flex justify-space-between pb-2">
                  <div class="mr-1 grey--text">
                    Folio Fiscal:
                  </div>
                  <div>
                    {{ uuid }}
                  </div>
                </div>
                <div class="d-flex justify-space-between pb-2">
                  <div class="mr-1 grey--text">
                    Fecha de certificación:
                  </div>
                  <div>
                    {{ certificateDate }}
                  </div>
                </div>
                <div class="d-flex justify-space-between pb-2">
                  <div class="mr-1 grey--text">
                    Moneda:
                  </div>
                  <div>
                    {{ currency }}
                  </div>
                </div>
                <div class="d-flex justify-space-between pb-2">
                  <div class="mr-1 grey--text">
                    Número de certificado:
                  </div>
                  <div>
                    {{ certificate }}
                  </div>
                </div>
                <div class="d-flex justify-space-between pb-2">
                  <div class="mr-1 grey--text">
                    Versión:
                  </div>
                  <div>
                    {{ version }}
                  </div>
                </div>
                <div class="d-flex justify-space-between pb-2">
                  <div class="mr-1 grey--text">
                    CFDI:
                  </div>
                  <div>
                    {{ cfdi }}
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card>
                <v-data-table
                  :loading-text="table.title"
                  :loading="table.loading"
                  :headers="table.headers"
                  :items="table.data"
                  :options="table.options"
                  sort-by="name"
                  class="elevation-1">
                  <template v-slot:item.unit="{ item }">
                    {{ convertUnit(item.unit) }}
                  </template>
                  <template v-slot:item.quantity="{ item }">
                    {{ item.quantity | toFixNumber(2) | numberWithComma }}
                  </template>
                  <template v-slot:item.cost="{ item }">
                    {{ item.cost | toFixNumber(2) | numberWithComma | prefix('$') }}
                  </template>
                  <template v-slot:item.discount="{ item }">
                    {{ item.discount | toFixNumber(2) | numberWithComma | prefix('$') }}
                  </template>
                  <template v-slot:item.subtotal="{ item }">
                    {{ item.subtotal | toFixNumber(2) | numberWithComma | prefix('$') }}
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="8">
              <v-card height="100%">
                <div class="pa-2">
                  <v-row>
                    <v-col class="py-1">
                      <div class="grey--text">
                        Sello del SAT:
                      </div>
                      <div>
                        {{ firmSAT }}
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>
            <v-col md="4">
              <v-card height="100%">
                <div class="pa-2">
                  <v-row>
                    <v-col class="py-1" md="7">
                      <div class="grey--text">
                        Subtotal:
                      </div>
                    </v-col>
                    <v-col class="py-1">
                      <div class="text-right">
                        {{ subtotal | toFixNumber(2) | numberWithComma | prefix('$') }}:
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-1" md="7">
                      <div class="grey--text">
                        Descuento:
                      </div>
                    </v-col>
                    <v-col class="py-1">
                      <div class="text-right">
                        {{ discount | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-1" md="7">
                      <div class="grey--text">
                        Impuestos retenidos:
                      </div>
                    </v-col>
                    <v-col class="py-1">
                      <div class="text-right">
                        {{ retentions | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-1" md="7">
                      <div class="grey--text">
                        Impuestos trasladados:
                      </div>
                    </v-col>
                    <v-col class="py-1">
                      <div class="text-right">
                        {{ translations | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-1" md="7">
                      <div class="grey--text">
                        Total:
                      </div>
                    </v-col>
                    <v-col class="py-1">
                      <div class="text-right">
                        {{ total | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { taxes } from '@/utils/constants'
const { parseStringPromise } = require('xml2js')

export default {
  props: {
    isOpenDialog: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: () => ({})
    },
    file: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpen: false,
      overlay: false,
      relatedInvoice: {},
      type: '',
      emiter: {},
      receiver: {},
      folio: '',
      uuid: '',
      date: '',
      currency: '',
      depot: '',
      subtotal: 0,
      discount: 0,
      translations: 0,
      retentions: 0,
      retentionIva: 0,
      total: 0,
      payMethod: '',
      payForm: '',
      certificate: '',
      certificateDate: '',
      version: '',
      cfdi: '',
      firmSAT: '',
      table: {
        title: this.$i18n.t('sales.loading'),
        loading: false,
        headers: [
          { text: 'Clave', value: 'clave' },
          { text: 'Nombre', value: 'name' },
          { text: 'Cantidad', value: 'quantity', align: 'right' },
          { text: 'Unidad', value: 'unit' },
          { text: 'Costo', value: 'cost', align: 'right' },
          { text: 'Descuento', value: 'discount', align: 'right' },
          { text: 'Subtotal', value: 'subtotal', align: 'right' },
          { text: 'Importe', value: 'total', align: 'right' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          multiSort: false,
          mustSort: false,
          sortBy: [''],
          sortDesc: [],
          itemsPerPage: 15,
          page: 1
        }
      },
      taxes
    }
  },
  computed: {
    units () {
      return this.$store.state.login.units.data
    }
  },
  watch: {
    isOpenDialog: async function (val) {
      this.isOpen = val
      if (val) {
        await this.getInovice()
      }
    }
  },
  methods: {
    typesRelations (satId) {
      return {
        '01': 'Notas de Crédito de Documentos Relacionados',
        '02': 'Notas de Débito de los Documentos Relacionados',
        '03': 'Devolución de Mercancías sobre Facturas o Traslados Previos',
        '04': 'Sustitución de los CFDI Previos',
        '05': 'Traslados de Mercancías Facturados Previamente',
        '06': 'Factura Generada por los Traslados Previos',
        '07': 'CFDI por Aplicación de Anticipo',
        '08': 'Facturas Generadas por Pagos en Parcialidades',
        '09': 'Factura Generada por Pagos Diferido'
      }[satId]
    },
    closeDialog () {
      this.isOpen = false
      this.$emit('close')
    },
    getInovice: async function () {
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/orders/${this.order._id}/credit-notes/${this.file}`)
        const content = await parseStringPromise(response.content)
        const invoice = content['cfdi:Comprobante']
        const taxes = invoice['cfdi:Impuestos']
          ? invoice['cfdi:Impuestos'][0]
          : {}

        const translations = (taxes['$'] || {})['TotalImpuestosTrasladados'] ? taxes['$']['TotalImpuestosTrasladados'] : 0
        const retentions = (taxes['$'] || {})['TotalImpuestosRetenidos'] ? taxes['$']['TotalImpuestosRetenidos'] : 0
        const items = invoice['cfdi:Conceptos'][0]['cfdi:Concepto']
        const digitalCertificate = invoice['cfdi:Complemento'][0]['tfd:TimbreFiscalDigital'][0]['$']

        const products = items.map(product => {
          const productTaxes = product['cfdi:Impuestos']
            ? product['cfdi:Impuestos'][0]
            : null

          const translations = productTaxes
            ? productTaxes['cfdi:Traslados'][0]['cfdi:Traslado']
            : []

          const retentions = productTaxes
            ? productTaxes['cfdi:Retenciones']
              ? productTaxes['cfdi:Retenciones'][0]['cfdi:Retencion'].map(tax => {
                tax.$.IsRetention = true
                return tax
              })
              : []
            : []

          const taxes = translations.concat(retentions)
          const totalTaxes = taxes.reduce((acc, val) => {
            return acc + (val.$ ? Number(val.$.Importe || 0) : 0)
          }, 0)
          return {
            clave: product.$.ClaveProdServ,
            name: product.$.Descripcion,
            unit: product.$.ClaveUnidad,
            quantity: parseFloat(product.$.Cantidad),
            cost: parseFloat(product.$.ValorUnitario),
            discount: parseFloat(product.$.Descuento) || 0,
            subtotal: parseFloat(product.$.Importe),
            total: (parseFloat(product.$.Importe) - (parseFloat(product.$.Descuento) || 0) + totalTaxes)
          }
        })
        this.table.data = products
        this.table.total = products.length
        this.uuid = digitalCertificate['UUID']
        this.folio = invoice.$.Folio
        this.date = invoice.$.Fecha
        this.currency = invoice.$.Moneda
        this.depot = invoice.$.Almacen
        this.subtotal = parseFloat(invoice.$.SubTotal)
        this.discount = invoice.$.Descuento
          ? parseFloat(invoice.$.Descuento)
          : 0
        this.payMethod = invoice.$.MetodoPago
        this.payForm = invoice.$.FormaPago
        this.certificate = digitalCertificate.NoCertificadoSAT
        this.certificateDate = digitalCertificate.FechaTimbrado
        this.version = digitalCertificate.Version
        this.firmSAT = digitalCertificate.SelloSAT
        this.cfdi = invoice.$.Version
        this.retentions = retentions
        this.translations = translations
        this.total = parseFloat(invoice.$.Total)
        this.receiver = invoice['cfdi:Receptor'][0]['$']
        this.emiter = invoice['cfdi:Emisor'][0]['$']
        this.relatedInvoice = invoice['cfdi:CfdiRelacionados'][0]['cfdi:CfdiRelacionado'][0]['$']
        this.type = invoice['cfdi:CfdiRelacionados'][0]['$'].TipoRelacion
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    convertUnit (satCode) {
      const unit = this.units.find(u => u.satCode === satCode.toLowerCase())
      return unit ? unit.name : satCode
    }
  }
}
</script>
